<template>
  <div class="right-contx bgcolor-f6f5fa pull-right">
    <div class="top-titx font-16">
      我的培训
    </div>
    <div class="layui-col-md12 class-container">
      <div
        v-if="flag"
        style="line-height: 600px;color:lightgray;font-size: 16px;text-align: center   ;"
      >
        暂无培训计划
      </div>
      <div v-for="(item, index) in trainList" :key="index" class="class-item">
        <img
          class="class-item-img"
          src="../../../../static/img/default-class.jpg"
        />

        <div class="class-item-content">
          <h2 class="class-item-title">计划名称：{{ item.className }}</h2>
          <ul class="class-item-list">
            <li>
              计划期限：{{ item.beginTime }}——<font color="red">{{
                item.endTime
              }}</font>
            </li>
            <li>
              计划要求：<font color="red"
                >公需课{{ item.publicPeriod }}课时、专业课{{
                  item.professionalPeriod
                }}课时</font
              >
            </li>
            <li>
              学习人数：<font color="#49af4a">{{ item.userNum }}</font>
            </li>
            <li>
              <a
                class="layui-btn study layui-btn-join"
                @click="beginStudy(item)"
                >开始学习</a
              >
            </li>
            <li style="display: flex;">
              学习进度：<v-progress-line
                :percent="item.classProgress"
                status="active"
                style="width: 70%;line-height: 15px;"
              >
              </v-progress-line>
            </li>
            <li>
              <i class="cusfont cusfont-shijian1"></i>剩余时长：<span
                class="color-666"
                >{{ item.residueDay }}天</span
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
  data() {
    return {
      trainList: [],
      flag: false
    };
  },
  created() {
    this.$parent.Cut(this.$parent.list[1], 0);
    //查询 个人中心培训计划
    this.loadData();
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    beginStudy(item) {
      this.$router.push({ path: "/trainPlanCourse/" + item.id });
    },

    loadData() {
      this.flag = false;
      let parames = new URLSearchParams();

      parames.append("userId", this.$storage.get("declareUser").id);
      parames.append("choiceState", 2);

      //获取 当前等级下的上传资料 列表
      this.$axios
        .post(this.serverUrl + "/class/getUserClassData", parames)
        .then(resp => {
          if (resp.data.code === 1) {
            resp.data.data.forEach(element => {
              element.beginTime = element.beginTime.substring(0, 10);
              element.endTime = element.endTime.substring(0, 10);

              element.residueDay = (
                (new Date(element.endTime).getTime() - new Date().getTime()) /
                (1000 * 60 * 60 * 24)
              ).toFixed(1);
            });

            this.trainList = resp.data.data;
            console.log(this.trainList);
            if (resp.data.data.length <= 0) {
              this.flag = true;
            }
          } else {
            this.flag = true;
          }
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: "服务器繁忙，稍后重试！",
            type: "error"
          });
        });
    }
  }
};
</script>

<style scoped>
.container:after {
  clear: both;
  content: ".";
  display: block;
  font-size: 0;
  height: 0;
  line-height: 0;
  visibility: hidden;
}

.clearfix:after {
  clear: both;
  content: ".";
  display: block;
  font-size: 0;
  height: 0;
  line-height: 0;
  visibility: hidden;
}

.color-666 {
  color: #666;
}

.cusfont {
  font-family: "cusfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.jindu200610 > div {
  position: absolute;
  height: 100%;
  border-radius: 6px;
  background: #2b83f3;
}

.jindu200610 {
  display: inline-block;
  width: 375px;
  margin-left: 0px !important;
}

.jindu200610 {
  width: 400px;
  position: relative;
  border-radius: 6px;
  height: 6px;
  background-color: #ddd;
  margin-left: 30px;
}

.layui-btn,
.layui-input,
.layui-select,
.layui-textarea,
.layui-upload-button {
  outline: 0;
  -webkit-appearance: none;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  box-sizing: border-box;
}

.layui-btn {
  display: inline-block;
  height: 38px;
  line-height: 38px;
  padding: 0 18px;
  background-color: #009688;
  color: #fff;
  white-space: nowrap;
  text-align: center;
  font-size: 14px;
  border: none;
  border-radius: 2px;
  cursor: pointer;
}

.study {
  background-color: #49af4a;
  position: absolute;
  right: 29px;
  top: 95px;
}

.class-item-list li {
  font-size: 13px;
  margin-bottom: 8px;
}

ol,
ul {
  list-style: none;
}

.class-item-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 21px;
}

.class-item-content {
  display: inline-block;
  vertical-align: top;
  padding: 3px 0px;
}

img {
  vertical-align: middle;
  border: 0;
  -ms-interpolation-mode: bicubic;
}

.class-item-img {
  height: 180px;
  width: 287px;
  margin-right: 40px;
}

.class-item {
  height: 232px;
  width: 100%;
  border-radius: 9px;
  padding: 24px 38px;
  color: #333333;
  position: relative;
  margin-bottom: 25px;
  background-color: #fff;
  border: 1px solid #f0f0ee;
}

.class-container {
  padding: 15px 0;
  min-height: 600px;
}

.font-16 {
  font-size: 16px;
}

.md-2018040807-xxw .top-titx {
  padding: 0 !important;
}

.md-2018040807-xxw .top-titx {
  line-height: 60px;
  padding: 0 28px;
  border-bottom: 1px solid #ddd;
}

.bgcolor-f6f5fa {
  background-color: unset !important;
}

.pull-right {
  float: right;
}

.bgcolor-f6f5fa {
  background: #f6f5fa;
}

.md-2018040807-xxw .right-contx {
  width: 940px;
  min-height: 450px;
  padding-bottom: 34px;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/train/personalCenter/trainPlanPersonal.vue